import React, { useCallback } from 'react'
import { analytics } from 'helpers'
import cx from 'classnames'

import { Button, openYouTubeModal } from 'sw-components'


import messages from './messages'


type VaultsExplainedButtonProps = {
  className?: string
}

const VaultsExplainedButton: React.FC<VaultsExplainedButtonProps> = (props) => {
  const { className } = props

  const handleClick = useCallback(() => {
    openYouTubeModal({
      title: messages.buttonTitle,
      id: 'Y_jqEqqw1kQ',
    })

    analytics.statistics.sendEvent('clickVaultsExplained')
  }, [])

  return (
    <div className={cx(className, 'text-center')}>
      <Button
        title={messages.buttonTitle}
        bgColor="moon"
        size="md"
        onClick={handleClick}
      />
    </div>
  )
}


export default React.memo(VaultsExplainedButton)
